import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/shared/PageHero";
import SectionHeading from "../components/shared/SectionHeading";
import SectionDivider from "../components/decor/SectionDivider";
import CTASection from "../components/shared/CTASection";
import Mandala from "../components/decor/Mandala";
import { PARAMPARA } from "../data/guruParampara";
import { PARAMPARA_KN } from "../data/guruParampara.kn";
import { IMG, OFFICIAL } from "../data/site";
import { Sparkles, Flower2 } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const COPY = {
  heroEye: { en: "Guru Parampara", kn: "ಗುರುಪರಂಪರೆ" },
  heroT: { en: "An unbroken chain of spiritual wisdom.", kn: "ಆಧ್ಯಾತ್ಮಿಕ ಜ್ಞಾನದ ಅಚ್ಛೇದಿತ ಸರಪಳಿ." },
  heroS: {
    en: "For over seven centuries, the Peetha of Sode Matha has been graced by an unbroken succession of Peethadhipatis dedicated to Dvaita philosophy, worship and service.",
    kn: "ಏಳು ಶತಮಾನಗಳಿಗೂ ಹೆಚ್ಚು ಕಾಲ, ಸೋದೆ ಮಠದ ಪೀಠವು ದ್ವೈತ ದರ್ಶನ, ಪೂಜೆ ಮತ್ತು ಸೇವೆಗೆ ಸಮರ್ಪಿತವಾದ ಪೀಠಾಧಿಪತಿಗಳ ಅಚ್ಛೇದಿತ ಪರಂಪರೆಯಿಂದ ಬೆಳಗಿದೆ.",
  },
  prevEye: { en: "Previous Peethadhipati", kn: "ಪೂರ್ವ ಪೀಠಾಧಿಪತಿಗಳು" },
  prevName: { en: "H.H. Sri Vishwottama Theertha Sripadangalavaru", kn: "ಶ್ರೀ ಶ್ರೀ ವಿಶ್ವೋತ್ತಮ ತೀರ್ಥ ಶ್ರೀಪಾದಂಗಳವರು" },
  prevP1: {
    en: "Sri Vishwottama Theertha Sripadangalavaru led the Sode Vadiraja Matha for several decades as its Peethadhipati. His tenure was marked by a remarkable expansion of the Matha's spiritual, educational and charitable activities - the strengthening of gurukulas, Sanskrit patashalas, the publication of Sri Madhvacharya's Sarvamoola Granthas, and extensive outreach across India and abroad.",
    kn: "ಶ್ರೀ ವಿಶ್ವೋತ್ತಮ ತೀರ್ಥ ಶ್ರೀಪಾದಂಗಳವರು ಹಲವಾರು ದಶಕಗಳ ಕಾಲ ಸೋದೆ ವಾದಿರಾಜ ಮಠವನ್ನು ಪೀಠಾಧಿಪತಿಗಳಾಗಿ ಮುನ್ನಡೆಸಿದರು. ಅವರ ಆಡಳಿತ ಕಾಲದಲ್ಲಿ ಮಠದ ಆಧ್ಯಾತ್ಮಿಕ, ಶೈಕ್ಷಣಿಕ ಹಾಗೂ ಧರ್ಮಾರ್ಥ ಚಟುವಟಿಕೆಗಳಲ್ಲಿ ಗಮನಾರ್ಹ ವಿಸ್ತರಣೆ ಸಂಭವಿಸಿತು - ಗುರುಕುಲಗಳ ಬಲವರ್ಧನೆ, ಸಂಸ್ಕೃತ ಪಾಠಶಾಲೆಗಳು, ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರ ಸರ್ವಮೂಲ ಗ್ರಂಥಗಳ ಪ್ರಕಟಣೆ ಮತ್ತು ಭಾರತದಾದ್ಯಂತ ಹಾಗೂ ವಿದೇಶಗಳಲ್ಲಿಯೂ ವ್ಯಾಪಕ ಪ್ರಸಾರ.",
  },
  prevP2: {
    en: "A luminous scholar, deeply devoted karyakartha of Sri Bhuvaraha and Sri Hayagriva, he is remembered by generations of devotees for his gracious presence, uncompromising adherence to Dvaita tradition, and tireless service to the community through Annadana and Vidyadana. He attained the sacred vrindavana in 2007.",
    kn: "ಪ್ರಜ್ವಲಿಸುತ್ತಿದ್ದ ವಿದ್ವಾಂಸರು, ಶ್ರೀ ಭೂವರಾಹ ಹಾಗೂ ಶ್ರೀ ಹಯಗ್ರೀವನ ಗಾಢ ಭಕ್ತ ಕಾರ್ಯಕರ್ತರಾಗಿದ್ದ ಅವರನ್ನು ಭಕ್ತ ಪೀಳಿಗೆಗಳು ತಮ್ಮ ಕರುಣಾಮಯ ಸಾನ್ನಿಧ್ಯ, ದ್ವೈತ ಪರಂಪರೆಗೆ ಬದ್ಧತೆ ಹಾಗೂ ಅನ್ನದಾನ-ವಿದ್ಯಾದಾನದ ಮೂಲಕ ಸಮಾಜ ಸೇವೆಗಾಗಿ ಸ್ಮರಿಸುತ್ತಾರೆ. ೨೦೦೭ರಲ್ಲಿ ಅವರು ಪವಿತ್ರ ವೃಂದಾವನ ಪ್ರವೇಶ ಮಾಡಿದರು.",
  },
  currEye: { en: "Current Peethadhipati", kn: "ಪ್ರಸ್ತುತ ಪೀಠಾಧಿಪತಿಗಳು" },
  currName: { en: "H.H. Sri Vishwavallabha Theertha Sripadangalavaru", kn: "ಶ್ರೀ ಶ್ರೀ ವಿಶ್ವವಲ್ಲಭ ತೀರ್ಥ ಶ್ರೀಪಾದಂಗಳವರು" },
  currP1: {
    en: "The current Peethadhipati graces the sacred throne of Sri Vadiraja Theertha, leading the Matha with devotion, scholarship and vision. Under his guidance, the Matha continues its centuries-old traditions of daily worship, discourse and Annadana, while expanding its outreach through publications, digital darshanas, and educational institutions.",
    kn: "ಪ್ರಸ್ತುತ ಪೀಠಾಧಿಪತಿಗಳು ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಪವಿತ್ರ ಸಿಂಹಾಸನವನ್ನು ಅಲಂಕರಿಸಿ, ಭಕ್ತಿ, ಪಾಂಡಿತ್ಯ ಹಾಗೂ ದೂರದೃಷ್ಟಿಯೊಂದಿಗೆ ಮಠವನ್ನು ಮುನ್ನಡೆಸುತ್ತಿದ್ದಾರೆ. ಅವರ ಮಾರ್ಗದರ್ಶನದಲ್ಲಿ ಮಠವು ದೈನಂದಿನ ಪೂಜೆ, ಪ್ರವಚನ ಹಾಗೂ ಅನ್ನದಾನದ ಶತಮಾನಗಳ ಪರಂಪರೆಯನ್ನು ಮುಂದುವರೆಸುತ್ತಾ, ಪ್ರಕಟಣೆಗಳು, ಡಿಜಿಟಲ್ ದರ್ಶನಗಳು ಹಾಗೂ ಶೈಕ್ಷಣಿಕ ಸಂಸ್ಥೆಗಳ ಮೂಲಕ ಪ್ರಸಾರವನ್ನು ವಿಸ್ತರಿಸುತ್ತಿದೆ.",
  },
  currP2: {
    en: "His discourses on the works of Sri Madhvacharya and Sri Vadiraja Theertha continue to inspire scholars and devotees around the world.",
    kn: "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಹಾಗೂ ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಕೃತಿಗಳ ಮೇಲಿನ ಅವರ ಪ್ರವಚನಗಳು ಪ್ರಪಂಚದಾದ್ಯಂತ ವಿದ್ವಾಂಸರು ಹಾಗೂ ಭಕ್ತರಿಗೆ ಸ್ಫೂರ್ತಿ ನೀಡುತ್ತಿವೆ.",
  },
  readMessages: { en: "Read Messages", kn: "ಸಂದೇಶಗಳನ್ನು ಓದಿ" },
  recentActivities: { en: "Recent Activities", kn: "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆಗಳು" },
  explorerEye: { en: "Parampara Explorer", kn: "ಪರಂಪರಾ ಅನ್ವೇಷಕ" },
  explorerT: { en: "Walk through the lineage", kn: "ಪರಂಪರೆಯಲ್ಲಿ ವಿಹರಿಸಿ" },
  explorerS: { en: "Select a Peethadhipati to learn about their contributions.", kn: "ಪೀಠಾಧಿಪತಿಗಳ ಕೊಡುಗೆಗಳ ಬಗ್ಗೆ ತಿಳಿಯಲು ಆಯ್ಕೆಮಾಡಿ." },
  preserved: { en: "Preserved in the unbroken lineage of Sri Vadiraja Theertha", kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಅಚ್ಛೇದಿತ ಪರಂಪರೆಯಲ್ಲಿ ಸಂರಕ್ಷಿತ" },
  legacyEye: { en: "Legacy", kn: "ಪರಂಪರೆ" },
  legacyT: { en: "Centuries of unbroken tradition", kn: "ಶತಮಾನಗಳ ಅಚ್ಛೇದಿತ ಪರಂಪರೆ" },
  stat1: { en: "Years unbroken", kn: "ಅಚ್ಛೇದಿತ ವರ್ಷಗಳು" },
  stat2: { en: "Peethadhipatis", kn: "ಪೀಠಾಧಿಪತಿಗಳು" },
  stat3: { en: "Publications", kn: "ಪ್ರಕಟಣೆಗಳು" },
  stat4Val: { en: "Global", kn: "ಜಾಗತಿಕ" },
  stat4: { en: "Devotee family", kn: "ಭಕ್ತ ಪರಿವಾರ" },
  ctaEye: { en: "The living lineage", kn: "ಜೀವಂತ ಪರಂಪರೆ" },
  ctaT: { en: "Meet the deities worshipped by every Peethadhipati", kn: "ಪ್ರತಿ ಪೀಠಾಧಿಪತಿಗಳಿಂದ ಪೂಜಿಸಲ್ಪಡುವ ದೇವರುಗಳನ್ನು ಭೇಟಿ ಮಾಡಿ" },
  ctaP: { en: "Divine Deities", kn: "ದೇವರುಗಳು" },
  ctaS: { en: "History of the Matha", kn: "ಮಠದ ಇತಿಹಾಸ" },
};

const GuruParampara = () => {
  const { lang } = useLang();
  const L = (o) => (o && o[lang]) || (o && o.en) || "";
  const [selected, setSelected] = useState(PARAMPARA.length - 1);
  const s = PARAMPARA[selected];
  const knPontiff = (lang === "kn" && PARAMPARA_KN[s.name]) || null;
  const displayRole = (knPontiff && knPontiff.roleKn) || s.role;
  const displayNote = (knPontiff && knPontiff.noteKn) || s.note;
  return (
    <>
      <PageHero
        eyebrow={L(COPY.heroEye)}
        title={L(COPY.heroT)}
        subtitle={L(COPY.heroS)}
        image={IMG.templeCorridor}
      />

      {/* Previous Peethadhipati */}
      <section className="py-16" data-testid="previous-pontiff">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2 relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
              <img src={OFFICIAL.pontiffPrevious} alt="H.H. Sri Vishwottama Theertha Sripadangalavaru" className="w-full h-full object-cover" data-testid="previous-pontiff-image" />
            </div>
            <div className="absolute -top-6 -left-6 opacity-70"><Mandala size={160} color="#B65A14" opacity={0.6} /></div>
          </div>
          <div className="lg:col-span-3">
            <div className="overline text-[#B65A14] mb-3">{L(COPY.prevEye)}</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl text-[#3B2A1A] leading-tight">{L(COPY.prevName)}</h2>
            <div className="mt-2 text-[#B65A14] font-semibold">1934 - 2007</div>
            <div className="mt-4 gold-underline" />
            <p className="mt-6 text-[#3B2A1A]/85 leading-relaxed">{L(COPY.prevP1)}</p>
            <p className="mt-4 text-[#3B2A1A]/85 leading-relaxed">{L(COPY.prevP2)}</p>
          </div>
        </div>
      </section>

      {/* Current Peethadhipati */}
      <section className="py-16 bg-sand-texture" data-testid="current-pontiff">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 order-2 lg:order-1">
            <div className="overline text-[#B65A14] mb-3">{L(COPY.currEye)}</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl text-[#3B2A1A] leading-tight">{L(COPY.currName)}</h2>
            <div className="mt-4 gold-underline" />
            <p className="mt-6 text-[#3B2A1A]/85 leading-relaxed">{L(COPY.currP1)}</p>
            <p className="mt-4 text-[#3B2A1A]/85 leading-relaxed">{L(COPY.currP2)}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/publications" className="inline-flex items-center gap-2 rounded-full bg-[#B65A14] text-[#FBF7F0] px-6 py-3 text-sm font-semibold" data-testid="pontiff-messages">{L(COPY.readMessages)}</Link>
              <Link to="/events" className="inline-flex items-center gap-2 rounded-full border border-[#B65A14]/40 text-[#B65A14] px-6 py-3 text-sm font-semibold" data-testid="pontiff-activities">{L(COPY.recentActivities)}</Link>
            </div>
          </div>
          <div className="lg:col-span-2 order-1 lg:order-2 relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
              <img src={OFFICIAL.pontiffCurrent} alt="H.H. Sri Vishwavallabha Theertha Sripadangalavaru" className="w-full h-full object-cover" data-testid="current-pontiff-image" />
            </div>
            <div className="absolute -bottom-6 -right-6 opacity-70"><Mandala size={160} color="#D4AF37" opacity={0.6} /></div>
          </div>
        </div>
      </section>

      <SectionDivider variant="lotus" />

      {/* Interactive Timeline */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-8" data-testid="parampara-explorer">
        <SectionHeading
          eyebrow={L(COPY.explorerEye)}
          title={L(COPY.explorerT)}
          subtitle={L(COPY.explorerS)}
          align="center"
        />
        <div className="mt-14 grid lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2 space-y-2 max-h-[520px] overflow-y-auto pr-2" data-testid="parampara-list">
            {PARAMPARA.map((p, i) => (
              <button
                key={i}
                onClick={() => setSelected(i)}
                className={`w-full text-left flex items-center gap-4 p-4 rounded-xl border transition ${selected === i ? "border-[#D4AF37] bg-[#F2E7D5]/70" : "border-[#D4AF37]/20 bg-[#FBF7F0] hover:border-[#D4AF37]/50"}`}
                data-testid={`parampara-item-${i}`}
              >
                <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${selected === i ? "bg-[#B65A14] text-[#D4AF37]" : "bg-[#F2E7D5] text-[#B65A14]"}`}>
                  <Flower2 className="w-5 h-5" />
                </div>
                <div>
                  <div className="overline text-[#B65A14]">{p.period}</div>
                  <div className="font-serif-display text-base text-[#3B2A1A] leading-tight">{p.name}</div>
                </div>
              </button>
            ))}
          </div>
          <div className="lg:col-span-3">
            <div className="bg-[#FBF7F0] border border-[#D4AF37]/40 rounded-3xl p-8 sm:p-10 relative overflow-hidden min-h-[420px]" data-testid="parampara-detail">
              <div className="absolute -top-8 -right-8 opacity-25"><Mandala size={200} color="#D4AF37" opacity={0.7} /></div>
              <div className="overline text-[#B65A14] mb-3">{s.period}</div>
              <h3 className="font-serif-display text-3xl sm:text-4xl text-[#3B2A1A] leading-tight">{s.name}</h3>
              <div className="mt-2 text-[#B65A14] font-semibold text-sm">{displayRole}</div>
              <div className="mt-4 gold-underline" />
              <p className="mt-6 text-[#3B2A1A]/85 leading-relaxed">{displayNote}</p>
              <div className="mt-8 flex items-center gap-2 text-sm text-[#B65A14]"><Sparkles className="w-4 h-4" /> {L(COPY.preserved)}</div>
            </div>
          </div>
        </div>
      </section>

      <SectionDivider variant="mandala" />

      {/* Legacy stats */}
      <section className="py-16 bg-sand-texture relative overflow-hidden" data-testid="parampara-stats">
        <div className="absolute -bottom-20 -right-20 opacity-30 animate-mandala-slow"><Mandala size={340} color="#B65A14" opacity={0.5} /></div>
        <div className="max-w-7xl mx-auto px-4 lg:px-8 text-center">
          <SectionHeading eyebrow={L(COPY.legacyEye)} title={L(COPY.legacyT)} align="center" />
          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { v: "700+", l: L(COPY.stat1) },
              { v: "36+", l: L(COPY.stat2) },
              { v: "1000s", l: L(COPY.stat3) },
              { v: L(COPY.stat4Val), l: L(COPY.stat4) },
            ].map((st, i) => (
              <div key={i} className="bg-[#FBF7F0] border border-[#D4AF37]/30 rounded-2xl p-8">
                <div className="font-serif-display text-4xl text-[#B65A14]">{st.v}</div>
                <div className="text-xs uppercase tracking-widest text-[#3B2A1A]/70 mt-2">{st.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        eyebrow={L(COPY.ctaEye)}
        title={L(COPY.ctaT)}
        primary={{ label: L(COPY.ctaP), to: "/deities" }}
        secondary={{ label: L(COPY.ctaS), to: "/about" }}
        image={IMG.templeInterior}
      />
    </>
  );
};

export const GuruParamparaContent = GuruParampara;
export default GuruParampara;
